
import { DispatchLoading, DispatchType, isValidationResult } from 'domain/utils/ReactUtils';
import { RecuperarSenhaRequest } from '../../../types/recuperarSenha/recuperarSenhaRequest';
import { RecuperarSenhaService } from '../../../services/recuperarSenha/recuperarSenhaService';
import { RECUPERAR_SENHA } from '../../../types/recuperarSenha/recuperarSenha';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { StateType } from 'domain/types/base/base';

const service = new RecuperarSenhaService();

export function EnviarEmailRecuperacao(request: RecuperarSenhaRequest): AppThunk {
    return async (dispatch) => {

        // Dispatch loading state
        dispatch(DispatchLoading(RECUPERAR_SENHA, DispatchType.LOADING, 'Enviando email de recuperação...', StateType.Master));

        // Call service
        const result = await service.enviarEmailRecuperacao(request, RECUPERAR_SENHA);
        if (isValidationResult(result)) {
            dispatch({
                type: RECUPERAR_SENHA,
                payload: result
            });
        }
    }
}

export function LimparEstadoRecuperarSenha(): AppThunk {
    return (dispatch) => {
        dispatch({
            type: RECUPERAR_SENHA,
            payload: null
        });
    };
}